import React from 'react'
import { Button, Typography, theme } from 'antd'
import { PlusOutlined, FileTextOutlined } from '@ant-design/icons'
import { hexToRGBA } from '../../../../lib/utils'

const { Title } = Typography

const DischargeHeader = ({ onCreateNew }) => {
  const { token } = theme.useToken()

  return (
    <div style={{ display: 'flex', alignItems: 'center', marginBottom: '24px', position: 'relative' }}>
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          position: 'absolute',
          left: '50%',
          transform: 'translateX(-50%)'
        }}
      >
        <FileTextOutlined style={{ marginRight: '8px', fontSize: '24px', color: token.colorPrimary }} />
        <Title level={4} style={{ margin: 0, color: token.colorPrimary }}>
          Discharge Instructions
        </Title>
      </div>
      <div style={{ marginLeft: 'auto', marginRight: '20px' }}>
        <Button
          icon={<PlusOutlined style={{ color: token.colorSuccess }} />}
          onClick={onCreateNew}
          style={{
            background: hexToRGBA(token.colorSuccess, 0.1),
            borderColor: token.colorSuccess,
            color: token.colorSuccess,
            fontWeight: 'bold'
          }}
        >
          Create New Instructions
        </Button>
      </div>
    </div>
  )
}

export default DischargeHeader
